import { devices, theme } from '@/components/features/theme/theme';

import { css } from 'styled-components';

export const globalStyleBody = css`
	//root , html, body style
	html.lenis,
	html.lenis body {
		height: auto;
	}
	.lenis.lenis-smooth {
		scroll-behavior: auto !important;
	}
	.lenis.lenis-smooth [data-lenis-prevent] {
		overscroll-behavior: contain;
	}
	.lenis.lenis-stopped {
		overflow: hidden;
	}
	.lenis.lenis-smooth iframe {
		pointer-events: none;
	}
	#root {
		min-height: 100vh;
		overflow-x: hidden;
	}

	.fixed-left {
		z-index: 0 !important;
	}

	.split-child {
		overflow: hidden;
		display: inline-block;
	}

	.pt200 {
		padding-top: 200px !important;
		@media (max-width: 767px) {
			padding-top: 120px !important;
		}
	}

	.pb200 {
		padding-bottom: 200px !important;
		@media (max-width: 767px) {
			padding-bottom: 120px !important;
		}
	}

	:root {
		view-transition-name: root;
	}

	.overlay-main-bg {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100vw;
		height: 100vh;
		background: rgb(0 0 0 / 50%);
		backdrop-filter: blur(10px);
		z-index: 999999;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
	}

	//.has-scroll-smooth [data-scroll-section][data-scroll-section-id]:not([data-scroll-section-inview]) {
	//    transform: translateX(-200vw) !important;
	//}

	.cursor-inner-text {
		font-size: 12px;
		line-height: 12px;
	}

	.fixed-left {
		z-index: 0;
	}

	[data-scroll='true'] {
		will-change: transform;
	}

	// Removed: .has-scroll-smooth body { overflow: hidden !important; }
	// Since we disabled Lenis smooth scrolling to show custom scrollbar

	.anim-char {
	}

	.cursor,
	.cursor-inner-text,
	.image-wrapper-second,
	.fix-it-right-two,
	.fix-it-right,
	.fix-it-left-two,
	fix-it-left.fix-it-left-main,
	.fix-it-right-main {
		will-change: transform;
	}

	section[aria-live='polite'] {
		position: relative;
		z-index: 99999999999999999999999;
	}

	.swiper-button-disabled {
		opacity: 0.5;
	}

	.Toastify__toast-container,
	.notification-toast {
		z-index: 99999999;
	}

	.Toastify__toast-container {
		z-index: 9999999999999999 !important;
	}

	.cursor:before {
		background: #dd223f !important;
	}
	.-color-theme:before {
		display: none !important;
	}
	@media (min-width: 1px) {
		:root {
			--sm: ;
			--n-sm: initial;
			--md: ;
			--n-md: initial;
			--lg: ;
			--n-lg: initial;
			--xl: ;
			--n-xl: initial;
			--xxl: ;
			--n-xxl: initial;
			--xxxl: ;
			--n-xxxl: initial;
			--xxxxl: ;
			--n-xxxxl: initial;
		}
	}

	.desktop {
		display: block !important;
		visibility: visible !important;
	}

	html {
		font-size: 16px; /* Base font size */
		-webkit-text-size-adjust: 100%;
		overscroll-behavior: none;
		scroll-behavior: auto !important;
	}

	html,
	body {
		margin: 0;
		padding: 0;
		min-height: 100%;
		height: auto;
		scroll-behavior: smooth;
		font-weight: 400;
		font-size: 1rem; /* 16px converted to rem */
		line-height: 1.5rem; /* 24px converted to rem */
		letter-spacing: 0;
		text-rendering: optimizeLegibility;
		font-feature-settings: 'kern' 1;
		font-kerning: normal;
		background-color: #ffffff;
		//overflow: hidden; /* Required for Lenis smooth scrolling */

		${devices.md} {
			overflow-x: hidden !important;
			overflow-y: scroll !important;
		}

		/* Hide scrollbar for Chrome, Safari and Opera */

		&::-webkit-scrollbar {
			width: 8px;
			height: 8px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background: #ed2024;
			border-radius: 4px;
			transition: background 0.3s ease;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: #dd223f;
		}

		&::-webkit-scrollbar-corner {
			background: #f1f1f1;
		}

		/* Firefox scrollbar styling */
		scrollbar-width: thin;
		scrollbar-color: #ed2024 #f1f1f1;

		&.hidden {
			overflow: hidden !important;
		}
	}

	.paragraph {
		transition: all 1s cubic-bezier(0.25, 0.74, 0.22, 0.99) 0s;
		//filter: blur(4px) !important;
		//opacity: 1 !important;
		//transition-delay: 0.7s !important;
		//will-change: filter;
		//@media(max-width: 767px){
		//    filter: blur(0) !important;
		//    opacity: 1 !important;
		//    visibility: visible !important;
		//    transition-delay: 0.7s !important;
		//}
	}

	.paragraph.is-inview {
		//filter: blur(0) !important;
		//opacity: 1 !important;
		//visibility: visible !important;
		//transition-delay: 0.7s !important;
	}

	section {
		will-change: transform;
	}

	/* main wrapper after the body and from layout element */

	#smooth-content {
		will-change: transform;
	}

	.container {
		min-width: 85%;
		margin: auto;
	}

	${devices.xxl} {
		.container {
			min-width: 85%;
			margin: auto;
		}
	}

	${devices.ResponsiveTab} {
		.container,
		.container-lg,
		.container-md,
		.container-sm {
			min-width: 90%;
			margin: auto;
		}
	}

	${devices.sm} {
		.container,
		.container-sm {
			max-width: 100%;
		}
	}

	.cursor-media {
		display: none !important;

		video {
			display: none !important;
		}
	}

	.subtitle-ygen {
		color: rgba(21, 38, 55, 0.5);
		font-size: 1rem; /* 16px / 16 */
		font-style: normal;
		font-weight: 500;
		line-height: 1.5rem; /* 24px / 16 */
	}

	@media (max-width: 767px) {
		.subHeading {
			font-size: 2rem !important;
			font-style: normal !important;
			font-weight: 600 !important;
			line-height: 2.4rem !important;
			letter-spacing: -0.1rem !important;
			margin-bottom: 30px !important;

			strong {
				font-family: 'Ivy Mode';
				font-size: 2rem !important;
				font-style: normal !important;
				font-weight: 400 !important;
				line-height: 2.4rem !important;
				letter-spacing: -0.1rem !important;
			}
		}

		.largeHeader {
			font-size: 4.8rem;
		}
	}

	//video modal

	.modal.fade .modal-dialog {
		transform: translateX(100%);
	}

	.modal.show .modal-dialog {
		transform: translateX(0);
		@media (max-width: 1024px) {
			transform: translateX(0);
		}
	}

	.main-modal-video.modal-video.modal {
		background: transparent;
	}

	.modal-video {
		background-color: transparent;
		//height: 100vh;
		z-index: 99999;
		padding: 0 !important;
		transition: ${theme.transition};

		&.modal {
			background: white;
		}

		.modal-dialog {
			height: 100vh;
			background-color: transparent;
			min-width: 100%;
			margin: 0;
		}

		.modal-body {
			height: 100vh;
		}

		.modal-content {
			background-color: transparent;
		}

		iframe {
			height: 60vh;
			width: 60vw;
			margin: auto;
			position: absolute;
			inset: 0;
		}

		.close-modal {
			position: absolute;
			top: 40px;
			right: 30px;
			height: 30px;
			//cursor: pointer;
			z-index: 99;
		}

		@media (max-width: 768px) {
			.modal-content {
				//padding: 0 20px;

				iframe {
					width: 90vw;
					height: 60vh;
				}

				.close-modal {
					top: 80px;
					right: 20px;
				}
			}
		}
		@media (max-width: 550px) {
			.modal-content iframe {
				width: 90vw;
				height: 40vh;
			}
		}
	}

	.mb80 {
		margin-bottom: 80px;
		@media (max-width: 767px) {
			margin-bottom: 40px;
		}
	}

	.swiper-wrapper {
		will-change: transform;
	}

	.c-scrollbar {
		z-index: 9999;
	}
`;
